<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item :label="language['tbasedataconfig.configName']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'configName', validatorRules.configName]" :placeholder="language['tbasedataconfig.configNamePh']"></a-input>
        </a-form-item>
        <a-form-item :label="language['tbasedataconfig.configKey']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'configKey', validatorRules.configKey]" ></a-input><!--:placeholder="language['tbasedataconfig.configKeyPh']"-->
        </a-form-item>
        <a-form-item :label="language['tbasedataconfig.configValue']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'configValue', validatorRules.configValue]" ></a-input>
        </a-form-item>
        <a-form-item :label="language['tbasedataconfig.configType']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="radio" v-decorator="['configType', validatorRules.configType]" :trigger-change="true" dictCode="config_type" />
        </a-form-item>
        <a-form-item :label="language['tbasedataconfig.remark']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'remark', validatorRules.remark]" ></a-input>
        </a-form-item>
        <a-form-item :label="language['tbasedataconfig.activeFlag']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="radio" v-decorator="['activeFlag', validatorRules.activeFlag]" :trigger-change="true" dictCode="active_flag" />
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import { get, pick } from 'lodash';
  import { validateDuplicateValue } from '@/utils/util'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"

  export default {
    name: "TBmConfigModal",
    components: {
      JDictSelectTag,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:this.$store.getters.language['common.action'],
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        //校验

        url: {
          add: "/sys/basedata/tBmConfig/add",
          edit: "/sys/basedata/tBmConfig/edit",
        }
      }
    },
    created () {
    },
    computed: {
       language() {
         return this.$store.getters.language
       },
       validatorRules(){
                return {
                           configName: {rules: [
                             {required: true, message: this.language['tbasedataconfig.configNamePh']},
                           ]},
                           configKey: {rules: [
                             {required: true, message: this.language['tbasedataconfig.configKeyPh']},
                             {validator: (rule, value, callback) => validateDuplicateValue('t_bm_config', 'config_key', value, this.model.id,'', callback)},
                           ]},
                           configValue: {rules: [
                             {required: true, message: this.language['tbasedataconfig.configValuePh']},
                           ]},
                           configType: {rules: [
                             {required: true, message: this.language['tbasedataconfig.configTypePh']},
                           ]},
                           remark: {rules: [
                           ]},
                           activeFlag: {rules: [
                             {required: true, message: this.language['tbasedataconfig.activeFlagPh']},
                           ]},
                }
       }
    },
    methods: {
      add () {
        this.edit({configType:'0',activeFlag:'1'});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'configName','configKey','configValue','configType','remark','activeFlag'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }

        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'configName','configKey','configValue','configType','remark','activeFlag'))
      },


    }
  }
</script>